<template>
  <div>
    <c-search-box @enter="getList">
      <template slot="search">
        <div class="col-xs-12 col-sm-12 col-md-3 col-lg-3 col-xl-3">
          <c-plant type="search" name="plantCd" v-model="searchParam.plantCd" />
        </div>
        <div class="col-xs-12 col-sm-12 col-md-3 col-lg-3 col-xl-3">
          <c-datepicker
            :range="true"
            defaultStart="-6M"
            defaultEnd="1M"
            type="month"
            label="점검기간"
            name="period"
            v-model="searchParam.period"
          />
        </div>
        <div class="col-xs-12 col-sm-12 col-md-3 col-lg-3 col-xl-3">
          <c-dept 
            type="search" 
            label="주관부서" 
            name="deptCd" 
            v-model="searchParam.deptCd" />
        </div>
        <!-- <div class="col-xs-12 col-sm-12 col-md-3 col-lg-3 col-xl-3">
          <c-select
            :comboItems="stepItems"
            type="search"
            itemText="codeName"
            itemValue="code"
            name="useFlag"
            label="LBLPROGRESS"
            v-model="searchParam.hcfSelfCheckCompleteFlag"
          ></c-select>
        </div> -->
      </template>
    </c-search-box>
    <c-table
      ref="table"
      title="시설 자체점검 목록"
      tableId="facilitySelfCheck"
      :columns="grid.columns"
      :data="grid.data"
      :filtering="false"
      :columnSetting="false"
      :usePaging="false"
      @linkClick="linkClick"
    >
      <!-- 버튼 영역 -->
      <template slot="table-button">
        <q-btn-group outline >
          <c-btn v-if="editable" label="LBLREG" icon="add_circle" @btnClicked="addFacility" />
          <c-btn label="LBLSEARCH" icon="search" @btnClicked="getList" />
        </q-btn-group>
      </template>
    </c-table>
    <c-dialog :param="popupOptions"></c-dialog>
  </div>
</template>

<script>
import selectConfig from '@/js/selectConfig';
export default {
  name: 'hazard-facility-self-check',
  data() {
    return {
      searchParam: {
        plantCd: null,
        period: [],
        deptCd: null,
        hcfSelfCheckCompleteFlag: null,
      },
      grid: {
        columns: [
          {
            name: 'plantName',
            field: 'plantName',
            label: 'LBLPLANT',
            align: 'center',
            style: 'width:120px',
            sortable: false,
          },
          {
            name: 'selfCheckMonth',
            field: 'selfCheckMonth',
            label: '점검년월',
            align: 'center',
            style: 'width:150px',
            sortable: false,
          },
          {
            name: 'deptName',
            field: 'deptName',
            label: '주관부서',
            align: 'center',
            style: 'width:200px',
            sortable: false,
          },
          {
            name: 'selfCheckName',
            field: 'selfCheckName',
            label: '점검명',
            align: 'left',
            type: 'link',
            sortable: false,
          },
          {
            name: 'hcfSelfCheckCompleteFlagName',
            field: 'hcfSelfCheckCompleteFlagName',
            label: 'LBLPROGRESS',
            align: 'center',
            style: 'width:100px',
            sortable: false,
          },
          {
            // 결재진행단계
            name: 'approvalStatusName',
            field: 'approvalStatusName',
            label: 'LBL00001609',
            align: 'center',
            sortable: true,
            style: 'width:100px',
          },
        ],
        data: [],
      },
      stepItems: [
        { code: 'N', codeName: '작성중' },
        { code: 'Y', codeName: '완료' },
      ],  
      popupOptions: {
        isFull: true,
        // width: '80%',
        target: null,
        title: '',
        visible: false,
        top: '',
        param: {},
        closeCallback: null,
      },
      editable: true,
      listUrl: '',
    };
  },
  beforeCreate() {},
  created() {},
  beforeMount() {
    Object.assign(this.$data, this.$options.data());
  },
  mounted() {
    this.init();
  },
  beforeDestroy() {
  },
  methods: {
    init() {
      // role setting
      this.editable = this.$route.meta.editable;
      // url setting
      this.listUrl = selectConfig.env.facilitySelfCheck.mst.list.url
      // code setting
      // list setting
      this.getList();
    },
    getList() {
      this.$http.url = this.listUrl;
      this.$http.type = 'GET';
      this.$http.param = this.searchParam;
      this.$http.request((_result) => {
        this.grid.data = _result.data;
      },);
    },
    /* eslint-disable no-unused-vars */
    addFacility() {
      this.linkClick();
    },
    linkClick(row, col, index) {
      this.popupOptions.title = '시설 자체점검 상세'; // 시설 자체점검 상세
      this.popupOptions.param = {
        selfCheckMonthId: row ? row.selfCheckMonthId : '',
      };
      this.popupOptions.target = () => import(`${'./hazardFacilitySelfCheckDetailMonth.vue'}`);
      this.popupOptions.visible = true;
      this.popupOptions.closeCallback = this.closePopup;
    },
    closePopup() {
      this.popupOptions.target = null;
      this.popupOptions.visible = false;
      this.getList();
    },
  }
};
</script>
